// @flow
/** @jsx jsx */

import Text from '@zapier/common-components/src/components/Text';
import { jsx } from '@emotion/core';
import { marginToCss } from '@zapier/common-utils';
import { Border, Colors, Screen } from '@zapier/theme';

import type { Spacing } from '@zapier/common-utils';

const breakpoints = [Screen.queries.tabletPortraitPlus];
const mq = breakpoints.map(bp => `@media ${bp}`);

const containerCss = props => ({
  ...marginToCss(props.margin),
  display: 'flex',
  backgroundColor: Colors.storm,
  justifyContent: 'space-between',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  minHeight: '80px',
  borderRadius: Border.radius.default,
  [mq[0]]: {
    flexDirection: 'row',
  },
});

const textCss = {
  flex: '0 1 60%',
  paddingBottom: '10px',
  textAlign: 'center',
  [mq[0]]: {
    paddingBottom: 0,
    textAlign: 'left',
  },
};

const headingCss = {
  margin: 0,
  paddingBottom: '10px',
};

const asideCss = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
};

type Props = {
  /** Button to render */
  button: React.Node,
  /** Optional text for heading */
  headingText?: string,
  /** Image to render */
  image: React.Node,
  margin?: Spacing,
  /** Text for body */
  text: string,
};

const NudgeBar = (props: Props) => {
  return (
    <div css={containerCss(props)}>
      <div css={textCss}>
        {props.headingText && (
          <h3 css={headingCss}>
            <Text type="section-head">{props.headingText}</Text>
          </h3>
        )}
        <Text type="body">{props.text}</Text>
      </div>
      <aside css={asideCss}>
        {props.image}
        {props.button}
      </aside>
    </div>
  );
};

export default NudgeBar;
